<div class="page-content">
  <header-ras-search></header-ras-search>
  <search-ras-content></search-ras-content>
</div>
